import {
  instance,
} from './index';

const getTags = async (data) => {
  const res = await instance.post('/tags/all/', data).then((result) => result, (err) => {
    console.log('err', err);
    console.log('err', err.response);
  });
  return res;
};
const getTag = async (data) => {
  const res = await instance.get('/tags', {
    params: data,
  });
  return res;
};
const updateTag = (data) => {
  const res = instance.put('/tags', data);
  return res;
};
export {
  getTags,
  getTag,
  updateTag,
};
